<template>
  <a-modal v-model="visible" :title="$t('选择数据表')" width="80%" @ok="handleComplete">
    <a-form :labelCol="{ span: '6' }" :wrapperCol="{ span: 18 }" layout="inline">
      <a-row>
        <a-col :span="6">
          <a-form-item :label="$t('表名')">
            <a-input v-model="queryParams.tableName" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <div>
            <a-button type="primary" @click="handleSearch">{{ $t('查询') }}</a-button>
          </div>
        </a-col>
      </a-row>
    </a-form>
    <a-table rowKey="tableName" :pagination="pagination" :columns="columns" :dataSource="dataSource" :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: handleTableSelectionChange }" @change="handleTableChange"></a-table>
  </a-modal>
</template>
<script>
import { getDbTables } from '@/api/app/db'

export default {
  data() {
    return {
      queryParams: {},
      dataSource: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      },
      selectedRowKeys: [],
      selectedRows: [],
      visible: false,
      appId: null,
      db: null
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('数据库'),
          dataIndex: 'db'
        },
        {
          title: this.$t('表名'),
          dataIndex: 'tableName'
        },
        {
          title: this.$t('备注'),
          dataIndex: 'tableComment'
        },
      ]
    },
  },
  methods: {
    show(appId, db) {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.appId = appId
      this.db = db
      this.pagination.total = 0
      this.pagination.current = 1
      this.queryParams = {}
      this.dataSource = []
      this.refresh()
      this.visible = true
    },
    handleComplete() {
      if (this.selectedRows.length == 0) {
        return
      }
      this.$emit('ok', this.selectedRows)
      this.visible = false
    },
    handleTableSelectionChange(keys, rows) {
      this.selectedRowKeys = keys
      this.selectedRows = rows
    },
    handleSearch() {
      this.pagination.current = 1
      this.refresh()
    },
    refresh() {
        this.loadTableData({ pageNum: this.pagination.current, pageSize: this.pagination.pageSize, ...this.queryParams })
    },
    loadTableData(params) {
      getDbTables({ ...params, appId: this.appId, db: this.db }).then(res => {
        if (res.code === 0) {
          this.pagination.current = res.data.pageNum
          this.pagination.total = res.data.total
          this.dataSource = res.data.items
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    handleTableChange(page) {
      if (page.current == this.pagination.current) {
        return
      }
      this.loadTableData({ pageNum: page.current, pageSize: page.pageSize, ...this.queryParams })
    }
  }
}
</script>